module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-order-item":"Update Order Item","order-created":"Order created","failed-create-order":"Failed to create order"}}')
  delete Component.options._Ctor
}
